import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { User, Client, SagView, RecentClient } from '@store/models';
import { collapseRightTrigger } from '../../app.animations';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SkillebladeModalContainer } from '../skilleblade-modal/skilleblade-modal.container';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [collapseRightTrigger],
    standalone: false
})

export class SidebarComponent {
    @Input() currentUser: User;
    @Input() officeName: string;
    @Input() currentClient: Client;
    @Input() sidebarCollapsed = false;
    @Input() clientCases: SagView[];
    @Input() recentClients: RecentClient[];
    @Input() navigationUrl: string;
    @Output() toggleSidebar = new EventEmitter<boolean>();
    @Output() openStamarkiv = new EventEmitter<Client>();
    @Output() openClientCase = new EventEmitter<{clientCase: SagView, kid: string}>();
    hasLegacy = environment.legacyUrl !== '';

    constructor(
        private ngbModal: NgbModal
    ) {}

    onToggleSidebar() {
        this.toggleSidebar.emit(!this.sidebarCollapsed);
    }

    onOpenStamarkiv(client: Client) {
        this.openStamarkiv.emit(client);
    }

    onOpenSkilleblade() {
        this.ngbModal.open(SkillebladeModalContainer, {size: 'xl'});
    }

    onOpenClientCase(clientCase: SagView) {
        let kid: string;
        if (this.recentClients.length > 0) {
            kid = this.recentClients[0].recentClientDetails.kid.toString() || '';
        }
        this.openClientCase.emit({
            clientCase: clientCase,
            kid: kid
        });
    }

}
